/** Operational + template taxonomy — keep in sync with `drip_campaigns.campaign_type` and `drip_templates.campaign_type`. */

export const DRIP_CAMPAIGN_TYPES = [
  { value: 'lead_nurture', label: 'Lead nurture' },
  { value: 'reminders', label: 'Reminders' },
  { value: 'sales_follow_ups', label: 'Sales follow-ups' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 're_engagement', label: 'Re-engagement' },
  { value: 'event_campaigns', label: 'Event campaigns' },
] as const;

export type DripCampaignTypeSlug = (typeof DRIP_CAMPAIGN_TYPES)[number]['value'];
